import _sfc_main from "./component-library117.mjs";
import "./component-library118.mjs";
import normalizeComponent from "./component-library95.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c("div", { staticClass: "video-player" }, [_c(_setup.PlayPauseButton, { staticClass: "video-player__play-button", class: {
    "video-player__play-button--center": _vm.playButtonCentered && _setup.doShowPlayButton,
    "video-player__play-button--small": _vm.autoplay,
    "video-player__play-button--pause": !_setup.doShowPlayButton
  }, attrs: { "aria-label": _setup.doShowPlayButton ? _vm.playButtonAriaLabel : _vm.pauseButtonAriaLabel, "title": _setup.doShowPlayButton ? "Video abspielen" : "Video pausieren" }, on: { "input": _setup.togglePlay }, model: { value: _setup.isPlaying, callback: function($$v) {
    _setup.isPlaying = $$v;
  }, expression: "isPlaying" } }), _c("video", { ref: "videoElement", staticClass: "video-player__video", attrs: { "autoplay": _vm.autoplay && !_setup.isReducedMotion, "controls": _vm.controls, "loop": _vm.loop, "playsinline": _vm.playsinline, "poster": _setup.posterSrc, "preload": _vm.preload, "aria-label": _vm.videoAriaLabel }, domProps: { "muted": _vm.muted }, on: { "ended": function($event) {
    _setup.isPlaying = false;
  }, "pause": function($event) {
    _setup.isPlaying = false;
  }, "play": function($event) {
    _setup.isPlaying = true;
  }, "click": _setup.togglePlay } }, [_vm._t("default", function() {
    return [_c("source", { attrs: { "src": _setup.videoSrc, "type": `video/${_setup.type}` } })];
  }), _vm._v(" Your browser does not support the video tag. ")], 2)], 1);
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  "eac71d19",
  null,
  null
);
const VideoPlayer = __component__.exports;
export {
  VideoPlayer as default
};
